import React from 'react';
import {CircularProgress, Container} from '@mui/material';
import styled from '@emotion/styled/macro';

interface ILoadingViewProps {}

const ContainerStyled = styled(Container)`
  display: flex;
  margin-top: 30px;
`;
const CircularProgressStyled = styled(CircularProgress)`
  margin: auto;
`;

export const LoadingView: React.FC<ILoadingViewProps> = () => (
  <ContainerStyled>
    <CircularProgressStyled size={60} color="secondary"/>
  </ContainerStyled>
)
